import {interactiveDemoHotspotGql} from '../interactiveDemoHotspotGql';

export const interactiveDemo2023Gql = `... on landingPageContent2023_interactiveDemo_BlockType {
  typeHandle
  demoEntry {
    ... on interactiveDemoV2_interactiveDemoV2_Entry {
      introTitle:timelineIntroTitle
      outroTitle:timelineOutroTitle
      textAlign:interactiveDemoTextAlignment
      aspectRatioDesktop:interactiveDemoImageAspectRatioDesktop
      aspectRatioMobile:interactiveDemoImageAspectRatioMobile
      demoTheme:interactiveDemoTheme
      constrainWidth:interactiveDemoConstrainDesktopWidth
      hotspotTheme:interactiveDemoHotspotColor
      numbers:interactiveDemoNumberedHotspots
      interactiveDemoStaticImageDesktop {
        ... on images_Asset {
          uncropped1920w {
            srcset
            srcWebp
          }
        }
      }
      interactiveDemoStaticImageMobile {
        ... on images_Asset {
          uncropped1920w {
            srcset
            srcWebp
          }
        }
      }
      hotspotsDesktop:interactiveDemoHotspotSelectorDesktop {
        ... on interactiveDemoHotspotSelectorDesktop_hotspot_BlockType {
          coordinateX
          coordinateY
          ${interactiveDemoHotspotGql}
        }
      }
      hotspotsMobile:interactiveDemoHotspotSelectorMobile {
        ... on interactiveDemoHotspotSelectorMobile_hotspot_BlockType {
          coordinateX
          coordinateY
          ${interactiveDemoHotspotGql}
        }
      }
      interactiveDemoTimeline {
        ... on interactiveDemoTimeline_timelineBlock_BlockType {
          ${interactiveDemoHotspotGql}
          eyebrow
          timelineTitle
          image {
            ... on images_Asset {
              source:uncropped1920w {
                srcset
                srcWebp
              }
            }
            ... on svgIcons_Asset {
              icon:url
            }
          }
        }
      }
    }
  }
}`;
